<script>
export default {
  name: "Coffee",
}
</script>

<template>
  <svg data-v-9d510461="" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 21 21" class="coffee-icon"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M6.5 8.5h6a2 2 0 0 1 2 2V13a4.5 4.5 0 0 1-4.5 4.5H9A4.5 4.5 0 0 1 4.5 13v-2.5a2 2 0 0 1 2-2m8 2h1a2 2 0 1 1 0 4h-1M8.5 6.5v-4M10.5 6.5v-2"></path></g></svg>
</template>
